import { useEffect, useState } from 'react';
import { useDealConfiguratorContext } from '../DealConfigureScreen';
import { Button } from 'components/Button';
import { Money } from 'components/Money';
import { Text } from 'components/Text';
import { recalculateOtherFeesPrices, toFiniteNumber } from 'helpers/otherFeesCalculation';
import { React } from 'libs/react';
import { useQuoteContext } from 'modules/public/quote/QuoteScreen';
import { DealFeeListItem } from './DealFeeListItem';
import './DealFeeList.scss';
/**
 * @component DealFeeList
 * @since 1.0.0
 */
export function DealFeeList(props) {
    var _a;
    const { onTotalPriceChange, deal, editable } = props;
    const { updateOtherFees } = useDealConfiguratorContext();
    const quoteContext = useQuoteContext();
    const otherFees = (_a = deal === null || deal === void 0 ? void 0 : deal.otherFees) !== null && _a !== void 0 ? _a : [];
    const [isOtherFees, setIsOtherFees] = useState(true);
    const [total, setTotal] = useState(otherFees.reduce((acc, curr) => acc + toFiniteNumber(curr.price), 0));
    /**
     * Recalculate all linked fees in one pass when the deal changes.
     * Doing this per DealFeeListItem caused race conditions: later items
     * overwrote earlier price updates with a stale otherFees array.
     */
    useEffect(() => {
        var _a;
        if (!((_a = deal === null || deal === void 0 ? void 0 : deal.otherFees) === null || _a === void 0 ? void 0 : _a.length)) {
            return;
        }
        const recalculated = recalculateOtherFeesPrices(deal);
        const changed = recalculated.some((otherFee, index) => toFiniteNumber(otherFee.price).toFixed(2) !==
            toFiniteNumber(deal.otherFees[index].price).toFixed(2));
        if (!changed) {
            return;
        }
        updateOtherFees(recalculated);
        if (quoteContext === null || quoteContext === void 0 ? void 0 : quoteContext.updateDealOtherFees) {
            quoteContext.updateDealOtherFees(recalculated);
        }
    }, [deal]);
    useEffect(() => {
        setTotal(otherFees.reduce((acc, curr) => acc + toFiniteNumber(curr.price), 0));
    }, [deal]);
    /**
     * @function onPress
     * @since 1.0.o
     * @hidden
     */
    const onPress = () => {
        updateOtherFees([
            ...otherFees,
            { id: '', createdAt: '', updatedAt: '', description: '', price: 0 }
        ]);
        setIsOtherFees(true);
    };
    useEffect(() => onTotalPriceChange(total), [total]);
    if (!isOtherFees && !editable) {
        return null;
    }
    return (React.createElement("div", { className: "deal-fee-list" },
        React.createElement("div", { className: "deal-fee-list-heading" },
            React.createElement(Text, { className: "deal-fee-list-title", value: t('Others') })),
        React.createElement("div", { className: "deal-fee-list-content" },
            otherFees.map((otherFee, index) => (React.createElement(DealFeeListItem, { deal: deal, index: index, fee: otherFee, editable: editable, key: otherFee.id || index }))),
            isOtherFees && (React.createElement("div", { className: "deal-fee-list-item deal-fee-list-item-total" },
                React.createElement("div", { className: "deal-fee-list-item-head" },
                    React.createElement(Text, { className: "deal-fee-list-item-text-description", value: t('Total') }),
                    total != 0 ? (React.createElement(Money, { className: "deal-fee-list-item-text-price", value: total })) : (React.createElement(Text, { className: "deal-fee-list-item-text-price", value: t('To be determined') }))),
                React.createElement("div", { className: "deal-fee-list-item-foot" })))),
        editable && (React.createElement("div", null,
            React.createElement(Button, { style: "outline", label: t('Add'), onPress: onPress })))));
}
